import React from 'react';
import StorageOptimizationDashboard from '../components/documents/StorageOptimizationDashboard';

export default function StorageOptimization() {
  return <StorageOptimizationDashboard />;
}
